import React from "react"
import { useTranslation } from "react-i18next"
import ProductData from "./ProductData"
import ProductDownloads from "./ProductDownloads"

const ProductDataGrid = ({ entry }) => {
  const { t } = useTranslation()

  let applicationData = []
  if (entry?.mainApplicationArea?.values.length > 0) {
    applicationData.push({
      label: `${t("generic.tabs.main_application")}`,
      items: entry?.mainApplicationArea?.values,
      originId: entry?.mainApplicationArea?.originId,
    })
  }
  if (entry?.sideApplicationArea?.values.length > 0) {
    applicationData.push({
      label: `${t("generic.tabs.other_application")}`,
      items: entry?.sideApplicationArea?.values,
      originId: entry?.sideApplicationArea?.originId,
    })
  }

  return (
    <section className="py-10 my-10 -mb-px bg-gray-100">
      <div className="max-w-screen-xl mx-auto px-grid">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {entry?.technicalData && (
            <div className="w-full bg-white">
              <ProductData
                keyValueItems={entry?.technicalData}
                title={t("generic.tabs.technical_data")}
              />
            </div>
          )}
          <div className="w-full bg-white">
            {applicationData.length > 0 && (
              <ProductData
                nestedKeyValueItems={applicationData}
                title={t("generic.tabs.application_areas")}
              />
            )}
            <ProductData
              keyValueItems={entry?.commercialData}
              title={t("generic.tabs.business_data")}
            />
            {entry.documentationFiles?.items?.length > 0 && (
              <ProductDownloads
                title={t("generic.tabs.documents")}
                downloads={entry.documentationFiles}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductDataGrid
